import { ToolCategory } from '../types';

export const toolCategories: ToolCategory[] = [
  {
    id: 'image',
    name: 'Image Tools',
    description: 'Convert, compress, and edit images',
    icon: 'Image',
    tools: [
      {
        id: 'webp-to-jpg',
        name: 'WEBP to JPG',
        description: 'Convert WEBP images to JPG format',
        category: 'image',
        icon: 'FileImage',
        keywords: ['webp', 'jpg', 'convert', 'image']
      },
      {
        id: 'png-to-jpg',
        name: 'PNG to JPG',
        description: 'Convert PNG images to JPG format',
        category: 'image',
        icon: 'FileImage',
        keywords: ['png', 'jpg', 'convert', 'image']
      },
      {
        id: 'jpg-to-png',
        name: 'JPG to PNG',
        description: 'Convert JPG images to PNG format',
        category: 'image',
        icon: 'FileImage',
        keywords: ['jpg', 'png', 'convert', 'image']
      },
      {
        id: 'image-compressor',
        name: 'Image Compressor',
        description: 'Compress images to reduce file size',
        category: 'image',
        icon: 'Minimize2',
        keywords: ['compress', 'optimize', 'reduce', 'size']
      },
      {
        id: 'image-cropper',
        name: 'Image Cropper',
        description: 'Crop images to custom dimensions',
        category: 'image',
        icon: 'Crop',
        keywords: ['crop', 'resize', 'dimensions', 'edit']
      },
      {
        id: 'image-to-base64',
        name: 'Image to BASE64',
        description: 'Convert images to BASE64 encoded strings',
        category: 'image',
        icon: 'Code',
        keywords: ['base64', 'encode', 'string', 'data']
      },
      {
        id: 'base64-to-image',
        name: 'BASE64 to Image',
        description: 'Convert BASE64 strings back to images',
        category: 'image',
        icon: 'FileImage',
        keywords: ['base64', 'decode', 'image', 'convert']
      },
      {
        id: 'image-color-inverter',
        name: 'Color Inverter',
        description: 'Invert colors in images',
        category: 'image',
        icon: 'Palette',
        keywords: ['invert', 'colors', 'negative', 'filter']
      }
    ]
  },
  {
    id: 'pdf',
    name: 'PDF Tools',
    description: 'Merge, convert, and manipulate PDF files',
    icon: 'FileText',
    tools: [
      {
        id: 'pdf-merger',
        name: 'PDF Merger',
        description: 'Merge multiple PDF files into one',
        category: 'pdf',
        icon: 'FileText',
        keywords: ['merge', 'combine', 'join', 'pdf']
      },
      {
        id: 'jpg-to-pdf',
        name: 'JPG to PDF',
        description: 'Convert JPG images to PDF format',
        category: 'pdf',
        icon: 'FileText',
        keywords: ['jpg', 'pdf', 'convert', 'image']
      },
      {
        id: 'pdf-to-jpg',
        name: 'PDF to JPG',
        description: 'Convert PDF pages to JPG images',
        category: 'pdf',
        icon: 'FileImage',
        keywords: ['pdf', 'jpg', 'convert', 'extract']
      },

      {
        id: 'pdf-metadata',
        name: 'PDF Metadata Viewer',
        description: 'View and extract PDF metadata',
        category: 'pdf',
        icon: 'Info',
        keywords: ['metadata', 'properties', 'info', 'details']
      },
      {
        id: 'txt-to-pdf',
        name: 'TXT to PDF',
        description: 'Convert text files to PDF format with proper formatting',
        category: 'pdf',
        icon: 'FileText',
        keywords: ['txt', 'text', 'convert', 'pdf', 'document']
      }
    ]
  },
  {
    id: 'text',
    name: 'Text & Format Tools',
    description: 'Count, format, and transform text',
    icon: 'Type',
    tools: [
      {
        id: 'text-analyzer',
        name: 'Text Analyzer',
        description: 'Count words, characters, sentences, and paragraphs with detailed analysis',
        category: 'text',
        icon: 'Hash',
        keywords: ['count', 'words', 'characters', 'sentences', 'paragraphs', 'analyze', 'statistics']
      },
      {
        id: 'bionic-reading',
        name: 'Bionic Reading',
        description: 'Convert text to bionic reading format',
        category: 'text',
        icon: 'Eye',
        keywords: ['bionic', 'reading', 'bold', 'speed']
      },
      {
        id: 'text-capitalizer',
        name: 'Text Capitalization Converter',
        description: 'Convert text to title case, sentence case, or first letter capitalization',
        category: 'text',
        icon: 'Type',
        keywords: ['title', 'sentence', 'first letter', 'format', 'case']
      },
      {
        id: 'uppercase-converter',
        name: 'Uppercase Converter',
        description: 'Convert text to uppercase',
        category: 'text',
        icon: 'Type',
        keywords: ['uppercase', 'caps', 'convert', 'format']
      },
      {
        id: 'lowercase-converter',
        name: 'Lowercase Converter',
        description: 'Convert text to lowercase',
        category: 'text',
        icon: 'Type',
        keywords: ['lowercase', 'convert', 'format', 'small']
      },
      {
        id: 'camelcase-converter',
        name: 'Programming Case Converter',
        description: 'Convert text to camelCase, PascalCase, snake_case, and kebab-case formats',
        category: 'text',
        icon: 'Type',
        keywords: ['camelcase', 'pascalcase', 'snakecase', 'kebabcase', 'convert', 'format', 'programming']
      },
      {
        id: 'duplicate-remover',
        name: 'Duplicate Line Remover',
        description: 'Remove duplicate lines from text',
        category: 'text',
        icon: 'Minus',
        keywords: ['duplicate', 'remove', 'unique', 'clean']
      },
      {
        id: 'text-sorter',
        name: 'Text Sorter',
        description: 'Sort text lines alphabetically',
        category: 'text',
        icon: 'ArrowUpDown',
        keywords: ['sort', 'alphabetical', 'order', 'arrange']
      }
    ]
  },
  {
    id: 'encryption',
    name: 'Encryption & Encoding',
    description: 'Encode, decode, and hash data',
    icon: 'Shield',
    tools: [
      {
        id: 'base64-encoder',
        name: 'Base64 Encode/Decode',
        description: 'Encode and decode Base64 strings',
        category: 'encryption',
        icon: 'Code',
        keywords: ['base64', 'encode', 'decode', 'string']
      },
      {
        id: 'md5-hash',
        name: 'MD5 Hash Generator',
        description: 'Generate MD5 hash from text',
        category: 'encryption',
        icon: 'Hash',
        keywords: ['md5', 'hash', 'generate', 'checksum']
      },
      {
        id: 'sha1-hash',
        name: 'SHA1 Hash Generator',
        description: 'Generate SHA1 hash from text',
        category: 'encryption',
        icon: 'Hash',
        keywords: ['sha1', 'hash', 'generate', 'checksum']
      },
      {
        id: 'sha256-hash',
        name: 'SHA256 Hash Generator',
        description: 'Generate SHA256 hash from text',
        category: 'encryption',
        icon: 'Hash',
        keywords: ['sha256', 'hash', 'generate', 'checksum']
      },
      {
        id: 'sha512-hash',
        name: 'SHA512 Hash Generator',
        description: 'Generate SHA512 hash from text',
        category: 'encryption',
        icon: 'Hash',
        keywords: ['sha512', 'hash', 'generate', 'checksum']
      },
      {
        id: 'url-encoder',
        name: 'URL Encode/Decode',
        description: 'Encode and decode URL strings',
        category: 'encryption',
        icon: 'Link',
        keywords: ['url', 'encode', 'decode', 'percent']
      },
      {
        id: 'html-encoder',
        name: 'HTML Encode/Decode',
        description: 'Encode and decode HTML entities',
        category: 'encryption',
        icon: 'Code',
        keywords: ['html', 'encode', 'decode', 'entities']
      }
    ]
  },
  {
    id: 'developer',
    name: 'Developer Tools',
    description: 'Format code and convert data',
    icon: 'Code2',
    tools: [
      {
        id: 'csv-json-converter',
        name: 'CSV ↔ JSON Converter',
        description: 'Convert between CSV and JSON formats',
        category: 'developer',
        icon: 'FileSpreadsheet',
        keywords: ['csv', 'json', 'convert', 'data', 'format']
      },
      {
        id: 'xml-formatter',
        name: 'XML Formatter',
        description: 'Format and beautify XML data',
        category: 'developer',
        icon: 'Code',
        keywords: ['xml', 'format', 'beautify', 'validate']
      },
      {
        id: 'markdown-to-html',
        name: 'Markdown to HTML',
        description: 'Convert Markdown to HTML',
        category: 'developer',
        icon: 'FileCode',
        keywords: ['markdown', 'html', 'convert', 'format']
      },
      {
        id: 'markdown-preview',
        name: 'Markdown Preview',
        description: 'Live Markdown preview with real-time rendering',
        category: 'developer',
        icon: 'Eye',
        keywords: ['markdown', 'preview', 'live', 'render', 'editor']
      },
      {
        id: 'ip-to-binary',
        name: 'IP to Binary',
        description: 'Convert IP addresses to binary',
        category: 'developer',
        icon: 'Globe',
        keywords: ['ip', 'binary', 'convert', 'network']
      },
      {
        id: 'ascii-converter',
        name: 'Text to ASCII',
        description: 'Convert text to ASCII codes',
        category: 'developer',
        icon: 'Hash',
        keywords: ['ascii', 'convert', 'text', 'codes']
      },
      {
        id: 'binary-text-converter',
        name: 'Text to Binary',
        description: 'Convert text to binary representation',
        category: 'developer',
        icon: 'Binary',
        keywords: ['binary', 'convert', 'text', 'bits']
      }
    ]
  },
  {
    id: 'converters',
    name: 'Converters & Utilities',
    description: 'Convert between different formats',
    icon: 'RefreshCw',
    tools: [
      {
        id: 'numbers-to-words',
        name: 'Numbers to Words',
        description: 'Convert numbers to written words',
        category: 'converters',
        icon: 'Hash',
        keywords: ['numbers', 'words', 'convert', 'spell']
      },
      {
        id: 'number-base-converter',
        name: 'Number Base Converter',
        description: 'Convert between binary, decimal, and hex',
        category: 'converters',
        icon: 'Calculator',
        keywords: ['binary', 'decimal', 'hex', 'base']
      },
      {
        id: 'timezone-converter',
        name: 'Timezone Converter',
        description: 'Convert time between timezones',
        category: 'converters',
        icon: 'Clock',
        keywords: ['timezone', 'time', 'convert', 'utc']
      },
      {
        id: 'qr-generator',
        name: 'QR Code Generator',
        description: 'Generate QR codes from text or URLs',
        category: 'converters',
        icon: 'QrCode',
        keywords: ['qr', 'code', 'generate', 'barcode']
      }
    ]
  }
];

export const getAllTools = () => {
  return toolCategories.flatMap(category => category.tools);
};